import { configureStore } from '@reduxjs/toolkit';
import commonReducer from './slice/FJCommonSlice';
import startLandingReducer from './slice/FJStartLandingSlice';
import generatingPageReducer from './slice/FJGeneratingPageSlice';
import settingPageReducer from './slice/FJSettingPageSlice';
import detailsPageReducer from './slice/FJDetailsPageSlice';
import shareReducer from './slice/FJShareSlice';
import modalsReducer, { showWarningModal } from './slice/FJModalsSlice';
import modalAggregation from './slice/modal/FJModalAggregation.ts';

export const store = configureStore({
    reducer: {
        common: commonReducer,
        startLanding: startLandingReducer,
        generatingPage: generatingPageReducer,
        settingPage: settingPageReducer,
        detailsPage: detailsPageReducer,
        modals: modalsReducer,
        share: shareReducer.reducer,
        modal: modalAggregation,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ['modals.warningModalData'],
                /** `showWarningModal` payload 含 ReactNode、回调等，不参与序列化校验 */
                ignoredActions: [showWarningModal.type],
            },
            immutableCheck: {
                warnAfter: 200, // 把阈值从32ms调到200ms
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
